import axios from 'axios';
import { useEffect, useState } from 'react';
import Button from 'react-bootstrap/Button';
import Card from 'react-bootstrap/Card';
import Form from 'react-bootstrap/Form';
import ListGroup from 'react-bootstrap/ListGroup';
import Container from 'react-bootstrap/Container';
import Main from '../../../layouts/Main/Main';
import { IActivityType } from '../../../types';
import { toast } from 'react-toastify';

const ActivityTypes = () => {
  const [types, setTypes] = useState<IActivityType[]>([]);
  const [name, setName] = useState('');

  const load = () => axios.get<IActivityType[]>('/api/activity-type').then((response) => setTypes(response.data));

  useEffect(() => {
    load().catch(() => toast.error('Unable to load activity types'));
  }, []);

  const handleSubmit = (event: React.FormEvent) => {
    event.preventDefault();
    axios
      .post('/api/activity-type', { name })
      .then(() => {
        setName('');
        return load();
      })
      .catch((error) => toast.error(error.response?.data?.message ?? 'Unable to save activity type'));
  };

  const handleDelete = (id: string) => {
    axios.delete(`/api/activity-type/${id}`).then(load).catch(() => toast.error('Unable to delete activity type'));
  };

  return (
    <Main breadcrumb={[{ name: 'Home', path: '/' }, { name: 'Activity types', path: '/activity-types', active: true }]}>
      <Container className="mt-3">
        <Card className="mb-3">
          <Card.Header>Add an activity type</Card.Header>
          <Card.Body>
            <Form onSubmit={handleSubmit}>
              <Form.Group className="mb-2">
                <Form.Label>Name</Form.Label>
                <Form.Control value={name} onChange={(event) => setName(event.target.value)} required />
              </Form.Group>
              <Button type="submit">Add</Button>
            </Form>
          </Card.Body>
        </Card>
        <Card>
          <Card.Header>Saved activity types</Card.Header>
          <ListGroup variant="flush">
            {types.map((item) => (
              <ListGroup.Item key={item._id} className="d-flex justify-content-between align-items-center">
                <span>{item.name}</span>
                <Button variant="outline-danger" size="sm" onClick={() => handleDelete(item._id)}>Delete</Button>
              </ListGroup.Item>
            ))}
          </ListGroup>
        </Card>
      </Container>
    </Main>
  );
};

export default ActivityTypes;
